import React, { useEffect, useRef } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/pro-light-svg-icons'

import { useSelector } from 'src/store/redux.store'
import { useSidemenu } from './sidemenu.context'

function convertToRemUnit(maxMobileQuery: number) {
  const getFontSizeBody = window.getComputedStyle(document.body, null).getPropertyValue('font-size')
  const fontSizeBody = Number(getFontSizeBody.replace('px', '')) || 16

  return `${maxMobileQuery / fontSizeBody}rem`
}

const SidemenuMobile = ({ tabIndex }) => {
  const user = useSelector(state => state.user)
  const { toggleMenu, maxMobileQuery } = useSidemenu()

  const sidemenuHamburgerRef = useRef<JSX.IntrinsicElements['hot-menu-item']>()

  function handleChatKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleMenu()
    }
  }

  useEffect(() => {
    const style = document.createElement('style')

    if (sidemenuHamburgerRef.current) {
      style.innerHTML = `
        :host {
          display: none;
        }

        @media (max-width: ${convertToRemUnit(maxMobileQuery)}) {
          :host {
            display: block;
            position: absolute;
            left: 0.5rem;
            top: 0.75rem;
            width: auto;
          }
        }
      `

      sidemenuHamburgerRef.current.shadowRoot.appendChild(style)
    }

    return () => style.remove()
  })
  return (
    user && (
      <div slot="header-actions">
        <hot-menu-item
          slot="button"
          class="sidemenu-mobile"
          onKeyDown={handleChatKeydown}
          onClick={toggleMenu}
          tabIndex={tabIndex}
          ref={sidemenuHamburgerRef}
        >
          <div className="hot-application-menu__icon">
            <FontAwesomeIcon icon={faBars} />
          </div>
        </hot-menu-item>
      </div>
    )
  )
}

export default React.memo(SidemenuMobile)
